<template>
	<div id="infoDom">
		<div class="left-top">
			<div class="title-top">
				<img src="../../../../static/imgV2/detail-title.png" alt="">
				<div class="title-top-text">{{ languageJson.RobotInformation }}</div>
			</div>
			<div class="selet">
				<el-select v-model="eventValue" @change="selectEvent(eventValue)" :placeholder=" languageJson.PleaseSelect ">
					<el-option v-for="item in robotList" :key="item.robotId" :label="item.name + '-' + item.robotTypeName" :value="item.robotId" :disabled="item.onlineStatus == '2' ? true : false">
					</el-option>
				</el-select>
			</div>
		</div>
		<div class="left-box">
			<div class="li">
				<div class="fl">
					<img src="../../../../static/imgV2/dl.png" alt="">
					<div>
						<div :class="languageCheck == 'English' ? 'title titleSize' : 'title'">{{ languageJson.quantityOfElectricity }}</div>
						<div class="nub">{{ robotVos.power }}<span>%</span> </div>
					</div>
				</div>
			</div>
			<div class="li">
				<div class="fl">
					<img src="../../../../static/imgV2/wl.png" alt="">
					<div>
						<div :class="languageCheck == 'English' ? 'title titleSize' : 'title'">{{ languageJson.Network }}</div>
						<div class="nub">{{ robotVos.onlineStatusName }}</div>
					</div>
				</div>
			</div>
			<div class="li" v-if="robotVos.robotType != '04' && robotVos.robotType != '05' && robotVos.robotType != '06' && robotVos.robotType != '07'">
				<div class="fl">
					<img src="../../../../static/imgV2/dy.png" alt="">
					<div>
						<div :class="languageCheck == 'English' ? 'title titleSize' : 'title'">{{ languageJson.batteryVoltage }}</div>
						<div class="nub">{{ robotVos.voltage ? robotVos.voltage : '0' }}<span>v</span> </div>
					</div>
				</div>
			</div>
			<div class="li">
				<div class="fl">
					<img style="min-width: 40%;" src="../../../../static/imgV2/ljyx.png" alt="">
					<div>
						<div :class="languageCheck == 'English' ? 'title titleSize' : 'title'">{{ languageJson.AccumulatedRun }}</div>
						<div class="nub" :style="{ fontSize: Number(robotVos.totalRunTime) >= 1000 ? '0.6vw' : '0.8vw' }">{{ robotVos.totalRunTime ? (Number(robotVos.totalRunTime) >= 1000 ? Math.round(Number(robotVos.totalRunTime)) : Number(robotVos.totalRunTime).toFixed(2)) : '0' }}<span>h</span> </div>
					</div>
				</div>
			</div>
			<div class="li">
				<div class="fl">
					<img style="min-width: 40%;" src="../../../../static/imgV2/ljlc.png" alt="">
					<div>
						<div :class="languageCheck == 'English' ? 'title titleSize' : 'title'">{{ languageJson.AccumulatedMileage }}</div>
						<div class="nub" :style="{ fontSize: Number(robotVos.totalMileage) >= 1000 ? '0.6vw' : '0.8vw' }">{{ robotVos.totalMileage ? (Number(robotVos.totalMileage) >= 1000 ? Math.round(Number(robotVos.totalMileage)): Number(robotVos.totalMileage).toFixed(2)) : '0' }}<span>km</span> </div>
					</div>
				</div>
			</div>
			<div class="li">
				<div class="fl">
					<img style="min-width: 40%;" src="../../../../static/imgV2/cdcs.png" alt="">
					<div>
						<div :class="languageCheck == 'English' ? 'title titleSize' : 'title'">{{ languageJson.chargingCycles }}</div>
						<div class="nub" :style="{ fontSize: Number(robotVos.powerNums) >= 1000 ? '0.6vw' : '0.8vw' }">{{ robotVos.powerNums ? (Number(robotVos.powerNums) >= 1000 ? Math.round(Number(robotVos.powerNums)) : Number(robotVos.powerNums)) : '0' }}<span></span> </div>
					</div>
				</div>
			</div>
			<div class="li">
				<div class="fl">
					<img src="../../../../static/imgV2/wd.png" alt="">
					<div>
						<div :class="languageCheck == 'English' ? 'title titleSize' : 'title'">{{ languageJson.Temperature }}</div>
						<div class="nub">{{ robotVos.temperature ? robotVos.temperature : '0' }}<span>℃</span> </div>
					</div>
				</div>
			</div>
			<div class="li">
				<div class="fl">
					<img src="../../../../static/imgV2/sd.png" alt="">
					<div>
						<div :class="languageCheck == 'English' ? 'title titleSize' : 'title'">{{ languageJson.Humidity }}</div>
						<div class="nub">{{ robotVos.humidity ? robotVos.humidity : '0'}}<span>%</span> </div>
					</div>
				</div>
			</div>
			<div class="li">
				<div class="fl">
					<img src="../../../../static/imgV2/pm.png" alt="">
					<div>
						<div :class="languageCheck == 'English' ? 'title titleSize' : 'title'">{{ languageJson.PM25 }}</div>
						<div class="nub">{{ robotVos.pm2_5 ? robotVos.pm2_5 : '0' }}<span>μg/m³</span> </div>
					</div>
				</div>
			</div>
			<div class="li">
				<div class="fl">
					<img src="../../../../static/imgV2/pms.png" alt="">
					<div>
						<div :class="languageCheck == 'English' ? 'title titleSize' : 'title'">{{ languageJson.PM10 }}</div>
						<div class="nub">{{ robotVos.pm10 ? robotVos.pm10 : '0'}}<span>μg/m³</span> </div>
					</div>
				</div>
			</div>
			<div class="li">
				<div class="fl">
					<img src="../../../../static/imgV2/yxms.png" alt="">
					<div>
						<div :class="languageCheck == 'English' ? 'title titleSize' : 'title'">{{ languageJson.OperatingMode }}</div>
						<div class="nub" :style="{ 'fontSize' : languageCheck == 'English' ? '0.7vw' : '0.8vw' }">{{ robotVos.ststusName ? robotVos.ststusName : languageJson.None }}</div>
					</div>
				</div>
			</div>
			<div class="li">
				<div class="fl">
					<img src="../../../../static/imgV2/jt.png" alt="">
					<div>
						<div :class="languageCheck == 'English' ? 'title titleSize' : 'title'">{{ languageJson.EMERGENCYSTOP }}</div>
						<div class="nub">{{ robotVos.buttonStopStatus == '1' ? languageJson.open : languageJson.close }}</div>
					</div>
				</div>
			</div>
			<div class="last-li" v-if="robotVos.robotType == '04' || robotVos.robotType == '05' || robotVos.robotType == '06' || robotVos.robotType == '07'">
			</div>
		</div>
	</div>
</template>

<script>
	import {
		robotSelect,
		robotDetail
	} from '@/api/indexV2'
	import {
		getItem,
	} from '@/utils/auth'
	export default {
		name: '',
		data() {
			return {
				languageJson: languageJson,
				languageCheck: localStorage.getItem('language'),
				eventValue: "",
				robotList: [],
				robotVos: {},
				timeClear: null
			}
		},
		props: {
			robotInfo: null,
			vSocketData: null
		},
		mounted() {
			let that = this
			that.timeClear = setInterval(() => {
				that.robotDetail(that.eventValue)
			}, 20000)
		},
		beforeDestroy() {
			let that = this
			if (that.timeClear) {
				clearInterval(that.timeClear)
				that.timeClear = null
			}
		},
		methods: {
			robotDetail(id) {
				let that = this
				robotDetail(id).then(res => {
					if (res && res.data) {
						that.robotVos = res.data
					}
				})
			},
			selectEvent(val) {
				this.$emit('changeRobot', val)
			},
			robotSelect(tid, rid) {
				let that = this
        let robotNumbers = this.$route.query.robotNumbers;
        robotSelect(tid).then(res => {
					if (res && res.data) {
					  if(robotNumbers){
              res.data = res.data.filter(item => robotNumbers.includes(item.number))
            }
            that.robotList = res.data;
						res.data.forEach(res => {
							if (res.robotId == rid) that.eventValue = res.robotId
						})
					}
				})
			}
		},
		watch: {
			robotInfo: {
				deep: true,
				immediate: true,
				handler(newVal, oldVal) {
					if (newVal.robotId && newVal.robotId != oldVal.robotId) {
						this.robotVos = newVal
						this.robotSelect(getItem('tenantInfoId'), newVal.robotId)
					}
				}
			},
			vSocketData: {
				deep: true,
				handler(newVal, oldVal) {
					let that = this
					if (newVal.socketType == '1') {
						if (newVal.robotId == that.robotInfo.robotId) {
							that.robotVos.buttonStopStatus = newVal.buttonStop
							that.robotVos.ststusName = newVal.ststusName
							that.robotVos.power = newVal.power
							that.robotVos.ststus = newVal.ststus
						}
					}
				}
			}
		}
	}
</script>

<style scoped lang="less">
	.left-top {
		display: flex;
		color: #fff;
		font-size: 16px;
		flex-wrap: wrap;
		justify-content: space-between;

		.selet {
			margin: 0.5vw;
		}
	}

	.title-top {
		display: flex;
		color: #fff;
		font-size: 0.8vw;
		align-items: center;
		justify-content: flex-start;
		margin: 0.5vw;
		padding-bottom: 0.3vw;
		border-bottom: 1px solid rgba(0, 240, 255, 0.1);
		&-text {
			text-shadow: 0 0 10px rgba(0, 240, 255, 0.4);
			background: linear-gradient(180deg, #FFFFFF 0%, #00e0ff 100%);
			-webkit-background-clip: text;
			-webkit-text-fill-color: transparent;
			font-weight: bold;
			color: #FFFFFF;
			letter-spacing: 2px;
		}

		img {
			width: 1vw;
			margin-right: 0.3vw;
			filter: drop-shadow(0 0 4px rgba(0, 240, 255, 0.5));
		}
	}

	#infoDom /deep/.el-select {
		width: 98%;
		margin: 0 auto;
	}
	#infoDom /deep/ .el-input--suffix .el-input__inner {
		background: rgba(0, 20, 60, 0.7);
		color: #b0e0ff;
		border: 1px solid rgba(0, 240, 255, 0.15);
		border-radius: 4px;
		height: 1.5vw;
		line-height: 1.5vw;
		font-size: 0.6vw;
		transition: all 0.3s ease;
		&:focus, &:hover {
			border-color: rgba(0, 240, 255, 0.4);
			box-shadow: 0 0 8px rgba(0, 240, 255, 0.15);
		}
	}

	#infoDom /deep/ .el-input__icon {
		height: 1.5vw;
		line-height: 1.5vw;
		font-size: 0.6vw;
		color: rgba(0, 240, 255, 0.5);
	}

	#infoDom /deep/ .el-select .el-input,
	.el-select-dropdown .el-select-dropdown__item {
		font-size: 0.7vw;
		height: 1.3vw;
		line-height: 1.3vw;
		width: 10vw;
	}

	.left-box {
		display: flex;             
		flex-wrap: wrap;      
		justify-content: space-around;
		align-items: center;
		margin: 0 8px;
		gap: 2px;      
	    max-height: 100%; 
		overflow-y: auto; 
		.li {
			width: 30%;        
			margin-bottom: 0.4vw;
			padding: 0.2vw 0.1vw;
			border-radius: 4px;
			background: linear-gradient(135deg, rgba(0, 20, 60, 0.5), rgba(0, 10, 35, 0.3));
			border: 1px solid rgba(0, 240, 255, 0.06);
			transition: all 0.3s ease;

			&:hover {
				border-color: rgba(0, 240, 255, 0.2);
				background: linear-gradient(135deg, rgba(0, 30, 80, 0.6), rgba(0, 15, 45, 0.4));
				box-shadow: 0 0 10px rgba(0, 240, 255, 0.08);
			}

			.fl {
				display: flex;
				justify-content: left;
				align-items: center;

				>img {
					width: 35%;
					margin-right: 5px;
					filter: drop-shadow(0 0 4px rgba(0, 240, 255, 0.3)) brightness(1.1);
				}

				.title {
					font-size: 0.6vw;
					color: rgba(180, 220, 255, 0.7);
					font-weight: 500;
					text-align: left;
					letter-spacing: 0.5px;
				}

				.titleSize {
					font-size: 0.55vw;
				}

				.nub {
					font-size: 0.85vw;
					color: #00f0ff;
					font-weight: 700;
					text-align: left;
					text-shadow: 0 0 8px rgba(0, 240, 255, 0.4);
					span {
						font-size: 0.6vw;
						color: rgba(0, 240, 255, 0.6);
						font-weight: 400;
					}
				}
			}
		}
		.last-li{
			width: 30%;        
			margin-bottom: 0.4vw;
			padding: 0.2vw 0.1vw;
		}
	}
</style>



// WEBPACK FOOTER //
// src/page/robotDetail/components/topleft.vue